export const firebase = {
  apiKey: "AIzaSyAv9Lv6effnnEmyX9TNh3X_KlHLlY_FkVU",
  authDomain: "pomtracker-501e1.firebaseapp.com",
  databaseURL: "https://pomtracker-501e1.firebaseio.com",
  projectId: "pomtracker-501e1",
  storageBucket: "pomtracker-501e1.appspot.com",
  messagingSenderId: "360031209538"
};

export default { firebase };



// WEBPACK FOOTER //
// ./src/config.js